import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b1be9cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "icon_wrapper",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _createElementVNode("img", {
      class: _normalizeClass([{ png_icon: _ctx.png }, { svg_icon: !_ctx.png }]),
      src: require(`@/assets/${_ctx.icon}`)
    }, null, 10, _hoisted_1),
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1)
  ]))
}